import React from "react";

const WebisteDisclaimer = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between pt-5">
          <div className="col-lg-12">
            <ul className="list-unstyled">
              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
                <h4 className="title_text text-dark mb-3">TopCoin UK Ltd - Website Disclaimer</h4>
                <p className="text-dark fw-semibold opacity-50 mb-0">Effective Date: 6 September 2026</p>
                <p className="text-dark fw-semibold opacity-50 mb-3">Company Registration No.: 16483297 | info@topcoinuk.com</p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">1. About This Disclaimer</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  This Website Disclaimer applies to your use of the <strong>TopCoin UK website and platform</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK Ltd ("TopCoin UK", "we", "us" or "our") operates an advertising, customer loyalty and rewards platform through which customers may discover participating companies, shops and retailers, access qualifying promotions, receive TopCoin and participate in applicable rewards programmes.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  This Disclaimer should be read together with the <strong>TopCoin UK General Terms & Conditions</strong>, <strong>Privacy Policy</strong>, <strong>Cookie Policy</strong> and, where applicable, the <strong>Captain TC Rewards Programme Terms & Conditions</strong>.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">2. General Information</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Information provided on the TopCoin UK website is provided for general information and for the operation and promotion of the TopCoin UK loyalty and rewards platform.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  We take reasonable steps to keep information accurate and up to date. However, information concerning participating businesses, products, prices, availability, promotions and rewards may change.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Customers should check the applicable offer and any relevant terms before making a purchase or participating in a promotion.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">3. TopCoin UK Loyalty and Rewards Platform</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK operates an <strong>advertising, promotional, loyalty and rewards platform</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin and Captain TC programme features are subject to the applicable TopCoin UK and Captain TC terms and qualifying conditions.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Not every company, shop, retailer, product, purchase or transaction displayed or promoted through TopCoin UK automatically qualifies for TopCoin or Captain TC rewards.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The applicable promotion or offer will determine eligibility.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">4. TopCoin</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin are digital loyalty and reward units used within the TopCoin UK platform.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin itself is not cash and has no standalone monetary or exchange value outside the TopCoin UK rewards system.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin should not be presented or understood as a promise of financial profit, interest or investment return.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The applicable <strong>TopCoin UK General Terms & Conditions</strong> govern the operation and use of TopCoin and the TopCoin Wallet.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">5. Captain TC Rewards Programme</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  The Captain TC Rewards Programme is a separate promotional loyalty and rewards programme operated by TopCoin UK.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Participation in Captain TC Rewards is subject to the <strong>Captain TC Rewards Programme Terms & Conditions</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Customers must have a valid and active Captain TC Rewards Card to receive Captain TC Rewards TopCoin and qualify for applicable Captain TC Rewards Card and Captain TC Gold Card rewards.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Customers with an active Captain TC Rewards Card should use their <strong>Captain TC Rewards Wallet</strong> to view their Captain TC Rewards TopCoin progress and applicable rewards earned.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">6. Participating Companies, Shops and Retailers</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may advertise or promote products, services and offers from participating companies, shops and retailers.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Unless expressly stated otherwise, TopCoin UK is not the seller of products or services purchased directly from a participating business.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The participating company, shop or retailer is responsible for its own products and services, including applicable pricing, product descriptions, availability, payment, delivery, returns, refunds and warranties.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The participating business's own terms and policies may apply.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Nothing in this Disclaimer affects a customer's statutory consumer rights.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">7. Affiliate Links and Commercial Relationships</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Some links on the TopCoin UK website may be <strong>affiliate or tracked links</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where a customer clicks a qualifying link or completes a qualifying purchase, TopCoin UK may receive a commission, advertising fee or other commercial benefit from the relevant retailer, affiliate network or commercial partner.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  This does not necessarily increase the price paid by the customer.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Where legally required, TopCoin UK will identify advertising, affiliate or other commercial content appropriately.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">8. Offers, Prices and Availability</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Information concerning products, services, prices, promotions and availability may originate from participating businesses or third-party providers.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Such information may change without immediate notice to TopCoin UK.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Customers should confirm important product information, current pricing, availability and purchase conditions with the relevant seller before completing a transaction.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">9. Third-Party Websites and Services</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  The TopCoin UK website may contain links to websites, services or platforms operated by third parties.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK does not control third-party websites and is not responsible for their content, availability, security, privacy practices or independent terms and conditions.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Customers should review the relevant third party's terms and privacy information before using its website or services.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">10. Gift Cards, Vouchers and Third-Party Rewards</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Some TopCoin UK or Captain TC rewards may be provided or fulfilled using third-party gift cards, eGift cards, vouchers, products or other promotional benefits.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  These rewards may be subject to the issuing provider's own conditions, including restrictions, availability and expiry dates.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin UK will provide applicable reward information where reasonably available.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">11. Website Availability</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK aims to maintain reliable access to its website and platform but does not guarantee uninterrupted or error-free availability.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Access may occasionally be affected by maintenance, technical problems, security measures, third-party services or circumstances outside TopCoin UK's reasonable control.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  We may temporarily restrict access where reasonably necessary to maintain or protect the website and Services.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">12. External Information</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where TopCoin UK displays or links to information supplied by participating companies, shops, retailers or other third parties, we take reasonable steps to present that information accurately.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  However, third-party information may change independently of TopCoin UK.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Customers should verify important information directly with the relevant provider where appropriate.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">13. Intellectual Property</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK names, branding, logos, website content, Captain TC branding and other proprietary materials are owned by TopCoin UK Ltd or used with appropriate permission, unless otherwise stated.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Third-party trademarks, logos and brand names remain the property of their respective owners.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The appearance of a third-party brand on TopCoin UK does not imply ownership by TopCoin UK.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">14. Limitation of This Disclaimer</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Nothing in this Disclaimer excludes or restricts any liability that cannot legally be excluded or restricted.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Nothing in this Disclaimer affects your statutory consumer rights.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The specific contractual rules governing your use of TopCoin UK and Captain TC Rewards are contained in the applicable <strong>Terms & Conditions</strong>, which should be read alongside this Disclaimer.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">15. Changes to This Disclaimer</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may update this Website Disclaimer from time to time to reflect changes to the website, platform, rewards programmes, participating businesses or applicable legal requirements.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The latest version will be published on the TopCoin UK website with its effective or updated date.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">16. Governing Law</h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  This Website Disclaimer is governed by the <strong>laws of England and Wales</strong>, subject to any mandatory consumer rights that apply to customers elsewhere in the United Kingdom.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">17. Contact Us</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  For questions about this Website Disclaimer, please contact:
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  <strong>TopCoin UK Ltd</strong><br />
                  Company Registration No.: 16483297<br />
                  Email: <strong>info@topcoinuk.com</strong>
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WebisteDisclaimer;
